import { State, Action, ActionType } from './types'

export const initialState = {
  find: '',
  replace: '',
  matchCase: false,
  searchResults: [],
  selectedResultIndex: 0,
  recentChanges: [],
}

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.clearSearch:
      return { ...state, find: '', replace: '', searchResults: [] }
    case ActionType.setFind:
      return { ...state, find: action.payload }
    case ActionType.setReplace:
      return { ...state, replace: action.payload }
    case ActionType.toggleMatchCase:
      return { ...state, matchCase: !state.matchCase }
    case ActionType.setSearchResults:
      return { ...state, searchResults: action.payload }
    case ActionType.setSelectedResultIndex:
      return { ...state, selectedResultIndex: action.payload }
    case ActionType.setRecentChanges:
      return { ...state, recentChanges: action.payload }
    case ActionType.recordChange:
      return { ...state, recentChanges: [action.payload, ...state.recentChanges] }
    case ActionType.undoChange:
      return {
        ...state,
        recentChanges: state.recentChanges.filter(change => change !== action.payload),
      }
    default:
      return state
  }
}
